import { OutlinedInput, styled } from "@mui/material";
import { ColorSAP, FONT_FAMILY } from "../../ontego-ui";

const Styled = {};

Styled.CustomOutlinedInput = styled(OutlinedInput)(({ whitebackground, endAdornment }) => ({
  width: "100%",
  background: whitebackground ? ColorSAP.neutral[0] : ColorSAP.neutral[10],
  paddingRight: endAdornment ? "40px !important" : 0,
  borderColor: ColorSAP.neutral[40],
  "& svg": {
    width: 24,
    height: 24,
    color: ColorSAP.neutral[40],
    marginRight: 12,
  },

  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: ColorSAP.neutral[40],
  },

  "& .MuiOutlinedInput-input": {
    border: "none",
    background: whitebackground ? ColorSAP.neutral[0] : ColorSAP.neutral[10],
    fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR,
    fontSize: 14,
    color: ColorSAP.neutral[100],
    "&::placeholder": {
      fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR,
      fontSize: 14,
      color: ColorSAP.neutral[40] + " !important",
      opacity: 1,
    },
  },

  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: ColorSAP.neutral[40],
  },

  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px !important",
    borderColor: ColorSAP.neutral[100] + " !important",
  },
}));

export default Styled;
